import { render, staticRenderFns } from "./DetailKeyValue.vue?vue&type=template&id=34ae2b8a"
import script from "./DetailKeyValue.js?vue&type=script&lang=js&external"
export * from "./DetailKeyValue.js?vue&type=script&lang=js&external"
import style0 from "./DetailKeyValue.vue?vue&type=style&index=0&id=34ae2b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports